import { SxProps } from "@mui/material";

export const sxPagination: SxProps = {
    width: 'auto',
    height: '32px',
    background: 'unset',
    color: 'unset',
    fontSize: 'unset',
    fontStyle: 'unset',
    fontWeight: 'unset',
    lineHeight: 'unset',
    position: 'unset',
    button: {
    fontFamily: 'UnimedSans-Bold',
    backgroundColor: '#EEE',
    color: '#5F5F5F'
    }
}

export const sxDemonstrativoSubtitle: SxProps = {
    color: '#4C4C4C',
    fontFamily: 'Unimed-Sans',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '24px',
    marginBottom: '25px',
    maxWidth: '580px'
}

export const sxTableContainer: SxProps = {
   borderRadius: '10px',
  width: '60%',
  '@media (max-width: 1135px)': {
      width: '60vw'
  },
  '@media (max-width: 1055px)': {
      width: '55vw'
  },
  '@media (max-width: 920px)': {
      width: '50vw'
  },
  '@media (max-width: 899px)': {
      width: '90vw'
  },
  '@media (max-width: 425px)': {
      width: '85vw'
  }
}

export const sxTable: SxProps = {
    borderRadius: '0px',
    boxShadow: 'none',
    border: 'none',
    width: '612px',
    maxWidth: '100%',
    '@media (max-width: 500px)': {
        width: '85vw'
    },
}

export const sxModal: SxProps = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: '578px',
    width: '85%',
    bgcolor: '#fff',
    borderRadius: '16px',
    border: 'none',
    boxShadow: '0px 4px 100px 0px rgba(56, 56, 56, 0.20)',
    padding: '32px',
    gap: '24px',
    maxHeight: '100vh',
    overflow: 'auto',
}

export const sxButtonGerarBoleto: SxProps = {
    borderRadius: '80px',
    height: '44px',
    padding: '24px 32px',
    '@media (max-width: 720px)': {
        width: 'stretch'
    }
}

export const sxSubtitle: SxProps = {
    color: '#4C4C4C',
    fontFamily: 'Unimed-Sans',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '400',
    maxWidth: '580px'
}

export const sxSubtitleBold: SxProps = {
    color: '#383838',
    fontFamily: 'UnimedSans-Bold',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '700',
    lineHeight: '24px',
    maxWidth: '580px'
}

export const sxValorTotal: SxProps = {
    color: '#383838',
    fontFamily: 'Unimed-Sans',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '24px',
    maxWidth: '580px',
}

export const sxButtonCopiarCodigoOutlined: SxProps = {
    borderRadius: '80px',
    marginTop: '10px',
    height: '44px',
    border: '2px solid var(--Primary-01-Medium, #00995D)',
    padding: '12px 32px 12px 32px'
}

export const sxLabelDataPagamento: SxProps = {
    marginBottom: '10px',
    marginTop: '32px'
}


export const sxTypographyAdvice: SxProps = {
    color: '#5F5F5F',
    fontFamily: 'Unimed-Sans',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '150%',
}

export const sxTypographyAdviceBold: SxProps = {
    color: '#383838',
    fontFamily: 'UnimedSans-Bold',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '150%',
}

export const sxTypographyAdviceTitle: SxProps = {
    color: '#383838',
    fontFamily: 'Unimed-Sans',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '700',
    lineHeight: '150%',
}

export const sxCodigoDeBarrasValor: SxProps = {
    color: '#156D44',
    align: 'center',
    fontFamily: 'UnimedSans-Bold',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '700',
    lineHeight: '24px',
}

export const sxModalTitle: SxProps = {
	fontFamily: 'UnimedSans-Bold', 
	fontSize: '18px', 
	lineHeight: '24px', 
	color: '#383838'
}

export const sxModalSubtitle: SxProps = {
	fontFamily: 'Unimed-Sans',
	fontWeight: 600,
	fontSize: '16px', 
	lineHeight: '24px', 
	color: '#717171',
}

export const sxTextField: SxProps = {
	width: '100%',
	input: {
		fontFamily: 'Unimed-Sans', 
		color: '#383838', 
		fontSize: '14px', 
	},
	'@media (max-width: 899px)': {
		width: '100%'
	}
}

export const sxCalendar: SxProps = {

	width: '100%',
	".MuiDateCalendar-root": {
			backgroundColor: '#00995D',
			boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.08);'
	},
	".MuiPickersCalendarHeader-root": {
			backgroundColor: '#00995D',
			color: '#fff',
			textTransform: 'uppercase',
			borderRadius: '10px 10px 0px 0px',
			paddingTop: '15px',
			paddingBottom: '15px',
			margin: '0',
			maxHeight: 'none',
	},
	".MuiPickersCalendarHeader-labelContainer": {
			fontFamily: 'Unimed-Sans',
			fontWeight: '700',
			
	},
	".MuiDayCalendar-root": {
			backgroundColor: "#fff"
	},
	".MuiPickersCalendarHeader-switchViewButton": {
			color: '#fff'
	},
	".MuiPickersArrowSwitcher-button": {
			color: '#fff'
	},
	".MuiDayCalendar-weekDayLabel": {
			fontFamily: 'Unimed-Sans',
			fontWeight: '700',
			color: '#4C4C4C'
	},
	".MuiPickersDay-root": {
			fontFamily: 'Unimed-Sans',
			color: '#4C4C4C',
			backgroundColor: '#fff'
	},
	"MuiPickersDay-root:focus": {
			backgroundColor: '#00995D'
	},
	"MuiPickersDay-root:hover": {
			backgroundColor: '#000'
	},
	".MuiPickersYear-yearButton": {
			fontFamily: 'Unimed-Sans',
			color: '#4C4C4C'
	},
	".Mui-selected": {
			backgroundColor: '#00995D',
			color: "#fff"
	},
	".Mui-selected:focus": {
			backgroundColor: '#00995D'
	},
	".Mui-selected:hover": {
			backgroundColor: '#00995D'
	},
	".Mui-disabled": {
			background: 'none'
	} ,
	'.MuiButton:hover .MuiButton-contained': {
			backgroundColor: '#00995D',
	}   
}



